import { Record, fromJS } from 'immutable';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"flux-actions"' has no exported member 'co... Remove this comment to see the full error message
import { handleActions, combineActions } from 'flux-actions';
import { TwoFactorAuthActionTypes } from '../actions/TwoFactorAuthActions';
import * as TwoFactorAuthSetupSteps from '../constants/TwoFactorAuthSetupSteps';
import { indexOfStep } from '../constants/TwoFactorAuthStepOrder';
import * as TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import * as TwoFactorAuthPrecedenceTypes from '../constants/TwoFactorAuthPrecedenceTypes';
import TwoFactorAuthStatus from '../records/TwoFactorAuthStatus';
const UNINITIALIZED_INDEX = -1;
const TwoFactorAuthState = Record({
  persistedStatus: new TwoFactorAuthStatus(),
  requiresUserToLogin: false,
  setupStepIndex: UNINITIALIZED_INDEX,
  method: TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR,
  precedence: TwoFactorAuthPrecedenceTypes.PRIMARY,
  qrCode: null,
  stagedSMSNumber: '',
  isErrorSendingSMS: undefined,
  verificationCodeAttempt: '',
  verificationCodeFailure: false,
  printedOrSavedBackupCodes: false,
  backupModalVisible: false,
  backupCodesLoading: false,
  setupForLogin: false,
  setupForLoginAccountInfo: undefined
}, 'TwoFactorAuthState');
const initialState = new TwoFactorAuthState();
export default handleActions({
  [TwoFactorAuthActionTypes.FETCHED_2FA_STATUS_SUCCESS](state, action) {
    return state.set('persistedStatus', action.payload.status);
  },
  [TwoFactorAuthActionTypes.USER_LOGIN_REQUIRED_FOR_2FA](state) {
    return state.set('requiresUserToLogin', true);
  },
  [TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_SUCCESS](state, action) {
    return state.setIn(['persistedStatus', 'backupCodesResponse'], fromJS(action.payload)).set('backupCodesLoading', false);
  },
  [TwoFactorAuthActionTypes.GENERATED_2FA_BACKUP_REQUEST](state) {
    return state.set('backupCodesLoading', true);
  },
  [TwoFactorAuthActionTypes.CLICKED_SETUP_2FA_BACKUP](state) {
    return state.set('backupModalVisible', true);
  },
  [TwoFactorAuthActionTypes.CLOSED_SETUP_2FA_BACKUP](state) {
    return state.set('backupModalVisible', false);
  },
  [TwoFactorAuthActionTypes.CLICKED_SETUP_2FA](state, action) {
    return state.merge({
      setupStepIndex: indexOfStep(TwoFactorAuthSetupSteps.CHOOSE_METHOD),
      precedence: action.payload.precedence,
      method: action.payload.stagedMethod
    });
  },
  [TwoFactorAuthActionTypes.STARTED_SETUP_2FA_FOR_LOGIN](state) {
    return state.merge({
      setupForLogin: true,
      setupStepIndex: indexOfStep(TwoFactorAuthSetupSteps.CHOOSE_METHOD),
      precedence: TwoFactorAuthPrecedenceTypes.PRIMARY
    });
  },
  [TwoFactorAuthActionTypes.SELECTED_2FA_METHOD](state, action) {
    return state.set('method', action.payload.method);
  },
  [TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD](state) {
    return state.set('setupStepIndex', state.method === TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR ? indexOfStep(TwoFactorAuthSetupSteps.REGISTER_HUBSPOT_WITH_GA) : indexOfStep(TwoFactorAuthSetupSteps.REGISTER_SMS));
  },
  [TwoFactorAuthActionTypes.COMPLETED_GA_REGISTRATION](state) {
    return state.set('setupStepIndex', indexOfStep(TwoFactorAuthSetupSteps.VERIFY_GOOGLE_AUTHENTICATOR));
  },
  [TwoFactorAuthActionTypes.CONFIRMED_SMS_NUMBER](state) {
    return state.merge({
      verificationCodeAttempt: '',
      verificationCodeFailure: false
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_SUCCESS](state, action) {
    const {
      response
    } = action.payload;
    return state.mergeDeep({
      setupStepIndex: state.method === TwoFactorAuthMethods.SMS ? indexOfStep(TwoFactorAuthSetupSteps.VERIFY_SMS) : state.setupStepIndex,
      persistedStatus: {
        [state.precedence.toLowerCase()]: response.config
      },
      qrCode: response.qrInfo,
      isErrorSendingSMS: false
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_2FA_METHOD_FAILURE](state) {
    if (state.method === TwoFactorAuthMethods.SMS) {
      return state.set('isErrorSendingSMS', true);
    }
    return state;
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_SUCCESS](state, action) {
    let nextStep = TwoFactorAuthSetupSteps.BACKUP_CODES;
    if (state.printedOrSavedBackupCodes) {
      nextStep = TwoFactorAuthSetupSteps.VERIFICATION_SUCCESSFUL;
    }
    return state.merge({
      persistedStatus: state.get('persistedStatus').set(state.precedence.toLowerCase(), action.payload.config),
      setupStepIndex: indexOfStep(nextStep)
    });
  },
  [TwoFactorAuthActionTypes.COMPLETED_BACKUP_CODES](state) {
    return state.set('setupStepIndex', indexOfStep(TwoFactorAuthSetupSteps.VERIFICATION_SUCCESSFUL));
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VERIFICATION_CODE_FAILURE](state) {
    return state.merge({
      verificationCodeFailure: true
    });
  },
  [TwoFactorAuthActionTypes.CHANGED_VERIFICATION_CODE_ATTEMPT](state, action) {
    return state.merge({
      verificationCodeAttempt: action.payload.codeAttempt,
      verificationCodeFailure: false
    });
  },
  [combineActions(TwoFactorAuthActionTypes.COMPLETED_2FA_SETUP, TwoFactorAuthActionTypes.CANCELLED_2FA_SETUP)](state) {
    if (state.setupForLogin) {
      return state;
    }
    return state.merge({
      setupStepIndex: UNINITIALIZED_INDEX,
      method: TwoFactorAuthMethods.GOOGLE_AUTHENTICATOR,
      precedence: TwoFactorAuthPrecedenceTypes.PRIMARY,
      qrCode: null,
      stagedSMSNumber: '',
      isErrorSendingSMS: undefined,
      verificationCodeAttempt: '',
      verificationCodeFailure: false,
      printedOrSavedBackupCodes: false,
      setupForLogin: false,
      setupForLoginAccountInfo: undefined
    });
  },
  [TwoFactorAuthActionTypes.CHANGED_SMS_REGISTRATION_NUMBER](state, action) {
    const {
      number
    } = action.payload;
    return state.merge({
      stagedSMSNumber: number,
      isErrorSendingSMS: undefined
    });
  },
  [TwoFactorAuthActionTypes.PRINTED_OR_SAVED_BACKUP_CODES](state) {
    return state.set('printedOrSavedBackupCodes', true);
  },
  [TwoFactorAuthActionTypes.TURNED_OFF_2FA_SUCCESS](state, action) {
    return state.set('persistedStatus', action.payload.status);
  },
  [TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_SUCCESS](state, action) {
    return state.merge({
      setupForLogin: true,
      setupForLoginAccountInfo: fromJS(action.payload.status)
    });
  },
  [TwoFactorAuthActionTypes.FETCHED_SETUP_PORTAL_2FA_STATUS_FAILURE](state, action) {
    return state.merge({
      setupForLogin: true,
      setupForLoginAccountInfo: fromJS({
        failed: true,
        portalId: action.payload.portalId
      })
    });
  },
  [TwoFactorAuthActionTypes.REDIRECT_TO_SECONDARY_2FA_SETUP](state, action) {
    return state.merge({
      setupStepIndex: indexOfStep(TwoFactorAuthSetupSteps.CHOOSE_METHOD),
      precedence: TwoFactorAuthPrecedenceTypes.SECONDARY,
      method: action.payload.stagedMethod,
      qrCode: null,
      stagedSMSNumber: '',
      isErrorSendingSMS: undefined,
      verificationCodeAttempt: '',
      verificationCodeFailure: false
    });
  }
}, initialState);